module.exports = __webpack_public_path__ + "static/media/playtech.345a3dcb.webp";